import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import { AsyncSelect, useAuthUser } from 'components';
import { notifyApiError } from 'components/layout/Toasts';

import { AdminApi, UserApi } from 'src/api';
import { userRoles } from 'src/constants/enums';
import { compareArrays, formatUserOption } from 'src/utils/helpers';

import style from '../Filtering.module.scss';

const FilterBySupplier = ({
  params,
  fullWidth,
  valueKey = 'id',
  labelKey = 'name',
  isMulti,
  queryParams = {},
  asUser,
  label,
  ...rest
}) => {
  const [selectedSupplier, setSelectedSupplier] = useState(isMulti ? [] : null);
  const [isLoading, setIsLoading] = useState(false);
  const user = useAuthUser();

  const paramValue = params.get('supplier');

  const setSingleValue = (supplier) => {
    const areValueTheSame = supplier?.value === paramValue;

    if (!areValueTheSame) {
      if (params.get('page')) {
        params.setFew([
          { key: 'supplier', value: supplier?.value },
          { key: 'page', value: '1' }
        ]);
      } else {
        params.set('supplier', supplier?.value);
      }
    }
  };

  const setMultiValue = (suppliers) => {
    const idsArray = suppliers?.map((sup) => sup.value);
    const areArrayTheSame = compareArrays(idsArray, paramValue);

    if (!areArrayTheSame) {
      if (params.get('page')) {
        params.setFew([
          { key: 'supplier', value: idsArray },
          { key: 'page', value: '1' }
        ]);
      } else {
        params.set('supplier', idsArray);
      }
    }
  };

  const onChangeHandler = (e) => {
    setSelectedSupplier(e);
    if (isMulti) {
      setMultiValue(e);
    } else {
      setSingleValue(e);
    }
  };

  useEffect(() => {
    const getSelectedElement = async () => {
      if (user?.role !== userRoles.admin) return params.remove('supplier');
      if (Array.isArray(paramValue)) return;
      //  TODO fill company data when array

      try {
        setIsLoading(true);
        const { data } = await AdminApi.getUser(paramValue);
        setSelectedSupplier(formatUserOption(data));
      } catch (err) {
        notifyApiError(err);
      } finally {
        setIsLoading(false);
      }
    };

    if (paramValue) getSelectedElement();
  }, []);

  if (user?.role !== userRoles.admin || asUser) {
    return (
      <AsyncSelect
        value={selectedSupplier}
        onChange={onChangeHandler}
        apiCallback={UserApi.getDistributors}
        valueKey={'id'}
        labelKey={'name'}
        label={label}
        placeholder={'Dostawca'}
        queryParams={{ pagination: 1, ...queryParams }}
        isClearable
        isMulti={isMulti}
        {...rest}
      />
    );
  }

  return (
    <AsyncSelect
      value={selectedSupplier}
      onChange={onChangeHandler}
      apiCallback={AdminApi.getUsers}
      valueKey={valueKey}
      label={label}
      labelKey={labelKey}
      placeholder={'Dostawca'}
      queryParams={{ role: userRoles.supplier, ...queryParams }}
      wrapperStyle={classNames(style.select, {
        [style.selected]: !!selectedSupplier,
        [style.fullWidth]: fullWidth
      })}
      isClearable
      isMulti={isMulti}
      {...rest}
    />
  );
};

export default FilterBySupplier;
